import { css } from 'styled-components';
var imageStyles = css(["width:100%;height:auto;max-width:100%;"]);
export default imageStyles;